import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useRef, useCallback } from 'react';
import { ScrollableContainer } from '@hh.ru/magritte-ui-scrollable-container';
import { s as styles, T as Tab } from './Tab-Dw8QYLZ4.js';
import { useTabs } from './useTabs.js';
import 'classnames';
import '@hh.ru/magritte-common-focus-visible';
import '@hh.ru/magritte-common-use-multiple-refs';
import '@hh.ru/magritte-ui-badge';
import '@hh.ru/magritte-ui-tooltip';
import '@hh.ru/magritte-ui-typography';
import '@hh.ru/magritte-common-keyboard';
import '@hh.ru/magritte-ui-breakpoint';

const defaultContainerCorrections = {};
const Tabs = ({ children, activeItemId, onChange, 'data-qa': dataQa = 'tab-list', containerCorrections = defaultContainerCorrections, disableContainerButtons, containerControlsRef, onScroll, mode = 'primary', ...tabsProps }) => {
    const [tabsContainer, setTabsContainer] = useState(null);
    const indicatorRef = useRef(null);
    const tabs = useTabs({
        activeItemId,
        indicatorRef,
        items: children,
        onChange,
        tabsContainerRef: { current: tabsContainer },
    });
    const setRefElement = useCallback((element) => {
        if (element && !tabsContainer) {
            setTabsContainer(element);
        }
    }, [tabsContainer]);
    if (!tabs?.length) {
        return null;
    }
    return (jsxs(ScrollableContainer, { ...containerCorrections, disableButtons: disableContainerButtons, ref: containerControlsRef, onScroll: onScroll, children: [jsx("div", { ...tabsProps, className: styles.tabs, "data-qa": dataQa, role: "tablist", ref: setRefElement, children: tabs.map((item) => (jsx(Tab, { ...item, mode: mode }, item.id))) }), mode === 'secondary' && (jsx("div", { className: styles.indicatorWrapper, children: jsx("div", { className: styles.indicator, ref: indicatorRef, "data-qa": "active-tab-indicator" }) }))] }));
};

export { Tabs };
//# sourceMappingURL=Tabs.js.map
